<template>
    <st-link-styled :href="href" :target="target" :color="color" @click="clickHandler">
        <slot />
    </st-link-styled>
</template>
<script>
import styled from "vue-styled-components";

const props = {
    color: {
        type: String,
        default: () => "black"
    }
};

const StLinkStyled = styled("a", props)`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${props => props.theme.color[props.color]};
    font-size: 1.6rem;
`;

export default {
    name: "StLink",
    props: {
        ...props,
        href: String,
        target: String,
        path: String,
        back: Boolean
    },
    methods: {
        clickHandler(ev) {
            ev.preventDefault();

            if (!this.$router) return;

            if (this.path) {
                this.$router.push(this.path);
                return;
            }

            if (this.back) {
                this.$router.go(-1);
                return;
            }
        }
    },
    components: {
        StLinkStyled
    }
};
</script>